module.exports = __webpack_public_path__ + "ef75bbb23fcdadd90b4b29373f1459b3.svg";